<template>
  <el-dialog
    class="dialog-container"
    :title="$t('zlfk.ckqb')"
    :visible.sync="dialogVisible"
    width="710px"
    append-to-body
  >
    <!-- 表格内容 -->
    <div class="table-container">
      <el-table
        ref="tableRef"
        stripe
        border
        highlight-current-row
        :data="vinList"
      >
        <!-- 序号 -->
        <el-table-column
          :label="$t('cart.xh')"
          width="60px"
          align="center"
          type="index"
          :render-header="$globalRenderHeader"
        ></el-table-column>
        <!-- 配件编码 -->
        <el-table-column
          property="faultCode"
          :label="$t('zlfk.pjbm')"
          min-width="120px"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 配件名称 -->
        <el-table-column
          property="faultName"
          :label="$t('zlfk.pjmc')"
          min-width="120px"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 订单批次号 -->
        <el-table-column
          property="orderBatch"
          :label="$t('zlfk.ddpch')"
          min-width="120px"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 故障配件数量 -->
        <el-table-column
          property="faultNumber"
          :label="$t('zlfk.gzpjsl')"
          min-width="120px"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 单车用量 -->
        <el-table-column
          property="singleDosage"
          :label="$t('zlfk.dcyl')"
          min-width="120px"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 故障车VIN码 -->
        <!-- <el-table-column
          prop="vin"
          :label="$t('zlfk.gzcvin')"
          min-width="120px"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column> -->
      </el-table>
    </div>
    <!-- <div slot="footer" class="text-center">
      <el-button
        class="primary-btn"
        type="primary"
        @click="dialogVisible = false"
        >{{ $t("zlfk.backto") }}</el-button
      >
    </div> -->
  </el-dialog>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      dialogVisible: false,
      vinList: [],
    };
  },
  mounted() {},
  methods: {
    // 初始化
    async init(data = []) {
      this.vinList = data || [];
      this.dialogVisible = true;
    },
  },
};
</script>